const o="++",t="||";export{t as SEARCH_URL_PARAM_DELIMITER_DOUBLE_PIPES,o as SEARCH_URL_PARAM_DELIMITER_TILDE};
